export interface ForemanEquipmentListItem {
  equipmentID: string;
  displayName: string;
}
